/* =========================================================================
   md-carrossel.js
   Setup dos carrosseis .md-car:
     - Inicializa cada [data-md-car] na pagina
     - Handler das setas (scrollBy com smooth)
     - Observer que atualiza barra de progresso conforme scroll
     - Clique na trilha pula para a posicao proporcional
     - ResizeObserver recalcula estado "travado" e progresso
     - MutationObserver pega carrosseis adicionados por AJAX
       (ex.: product-recommendations, section rendering API)
   Vanilla, defer-safe, sem dependencias.
   ========================================================================= */

(function () {
  'use strict';

  var INIT_FLAG = 'mdCarInit';
  var MIN_SCROLLABLE_PX = 2;
  var ARROW_PAGE_RATIO = 0.85;

  var prefersReducedMotion =
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function clamp(value, min, max) {
    if (value < min) return min;
    if (value > max) return max;
    return value;
  }

  function getProgress(trilho) {
    var scrollable = trilho.scrollWidth - trilho.clientWidth;
    if (scrollable <= MIN_SCROLLABLE_PX) return { scrollable: 0, ratio: 0 };
    var ratio = clamp(trilho.scrollLeft / scrollable, 0, 1);
    return { scrollable: scrollable, ratio: ratio };
  }

  function updateCar(car) {
    var trilho = car.querySelector('[data-md-car-trilho]');
    if (!trilho) return;

    var fita = car.querySelector('[data-md-car-fita]');
    var trilha = car.querySelector('[data-md-car-trilha]');
    var prev = car.querySelector('[data-md-car-prev]');
    var next = car.querySelector('[data-md-car-next]');

    var state = getProgress(trilho);

    if (state.scrollable <= MIN_SCROLLABLE_PX) {
      car.classList.add('md-car--travado');
      if (fita) fita.style.transform = 'translate3d(0,0,0)';
      if (prev) prev.disabled = true;
      if (next) next.disabled = true;
      return;
    }

    car.classList.remove('md-car--travado');

    if (fita && trilha) {
      var trilhaWidth = trilha.clientWidth;
      var fitaWidth = fita.offsetWidth;
      var maxTranslate = Math.max(0, trilhaWidth - fitaWidth);
      var x = Math.round(state.ratio * maxTranslate);
      fita.style.transform = 'translate3d(' + x + 'px,0,0)';
    }

    if (prev) prev.disabled = trilho.scrollLeft <= MIN_SCROLLABLE_PX;
    if (next) next.disabled = trilho.scrollLeft >= state.scrollable - MIN_SCROLLABLE_PX;
  }

  function scrollByPage(trilho, direction) {
    var amount = trilho.clientWidth * ARROW_PAGE_RATIO * direction;
    if (prefersReducedMotion) {
      trilho.scrollLeft = trilho.scrollLeft + amount;
    } else {
      trilho.scrollBy({ left: amount, behavior: 'smooth' });
    }
  }

  function initCar(car) {
    if (car.dataset[INIT_FLAG] === '1') return;
    var trilho = car.querySelector('[data-md-car-trilho]');
    if (!trilho) return;
    car.dataset[INIT_FLAG] = '1';

    var prev = car.querySelector('[data-md-car-prev]');
    var next = car.querySelector('[data-md-car-next]');
    var trilha = car.querySelector('[data-md-car-trilha]');

    if (prev) {
      prev.addEventListener('click', function () {
        scrollByPage(trilho, -1);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        scrollByPage(trilho, 1);
      });
    }

    var scrollRaf = 0;
    trilho.addEventListener(
      'scroll',
      function () {
        if (scrollRaf) return;
        scrollRaf = window.requestAnimationFrame(function () {
          scrollRaf = 0;
          updateCar(car);
        });
      },
      { passive: true }
    );

    if (trilha) {
      trilha.addEventListener('click', function (event) {
        var rect = trilha.getBoundingClientRect();
        if (rect.width <= 0) return;
        var ratio = clamp((event.clientX - rect.left) / rect.width, 0, 1);
        var scrollable = trilho.scrollWidth - trilho.clientWidth;
        var target = ratio * scrollable;
        if (prefersReducedMotion) {
          trilho.scrollLeft = target;
        } else {
          trilho.scrollTo({ left: target, behavior: 'smooth' });
        }
      });
    }

    if (typeof window.ResizeObserver === 'function') {
      var ro = new window.ResizeObserver(function () {
        updateCar(car);
      });
      ro.observe(car);
      ro.observe(trilho);
    } else {
      window.addEventListener('resize', function () {
        updateCar(car);
      });
    }

    // Imagens carregando podem alterar scrollWidth
    var imgs = trilho.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (!img.complete) {
        img.addEventListener(
          'load',
          function () {
            updateCar(car);
          },
          { once: true, passive: true }
        );
      }
    }

    updateCar(car);
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var cars = scope.querySelectorAll('[data-md-car]');
    for (var i = 0; i < cars.length; i++) {
      initCar(cars[i]);
    }
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  onReady(function () {
    initAll(document);

    if (typeof window.MutationObserver === 'function') {
      var mo = new window.MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var node = added[j];
            if (node.nodeType !== 1) continue;
            if (node.matches && node.matches('[data-md-car]')) {
              initCar(node);
            } else if (node.querySelectorAll) {
              initAll(node);
            }
          }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  });

  document.addEventListener('shopify:section:load', function (event) {
    var target = event && event.target ? event.target : document;
    initAll(target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var target = event && event.target ? event.target : null;
    if (!target || !target.querySelectorAll) return;
    var cars = target.querySelectorAll('[data-md-car]');
    for (var i = 0; i < cars.length; i++) {
      delete cars[i].dataset[INIT_FLAG];
    }
  });

  window.MdCarrossel = {
    init: initAll,
    initOne: initCar,
    refresh: updateCar
  };
})();
